class Api {
    constructor(address) {
        this._address = address;
    }

    postOrder(orderInfo) {
        return fetch(`${this._address}`,{
            method: 'POST',
            headers:{
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(orderInfo)
        })
            .then(res => {
                return this._getResponseData(res)
        })
    }

    _getResponseData(res) {
        if (!res.ok) {
            return Promise.reject(`Ошибка: ${res.status}`);
        }
        return res.json();
    }
    
}

const postOrder = new Api('https://api.mobo.su/wp-json/mobo/v1/order')

export default postOrder;